(ns app.front.view.group.admin.licence-revocation-letter-template-editor
  (:require [app.domain.contractor-registration.model :as cr-model]
            [app.domain.licence.model :as licence-model]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.front.view.group.admin.templates.language-selector :as lang-sel]
            [core.front.event :refer [<sub]])
  (:require-macros [core.util.util :as util]))

(defn view [tr group-id template inherited? replace-template]
  (let [template-id (:db/id template)
        images      (<sub [::gas/verdict-images group-id])
        cr?         (contains? (<sub [::gas/group-permit-types group-id]) :permit-type/CR)]
    [:div
     (when (<sub [::lang-sel/show-selector?])
       [ui/help (tr [:group-locales/multiple-locales-template-help])])
     [document-editor/editor
      (-> (util/mmap {:document-id        template-id
                      :read-only?         inherited?
                      :replace-template   replace-template
                      :title              [:h3 (tr [:licence/revocation-letter-template])]
                      :preview-url        (file-download/download-href
                                            :group/generate-licence-revocation-letter-template-preview-pdf
                                            {:group-id    group-id
                                             :template-id template-id})
                      :placeholders       (if cr?
                                            cr-model/revocation-letter-template-variables
                                            licence-model/revocation-letter-template-variables)
                      :html-fragment-type (if cr?
                                            :contractor-registration-revocation-letter-fragment/html-template
                                            :licence-revocation-letter-fragment/html-template)
                      :css-fragment-type  (if cr?
                                            :contractor-registration-revocation-letter-fragment/print-css
                                            :licence-revocation-letter-fragment/print-css)}
                     tr images group-id)
          (text-editor/with-external-edit-state ::main))]]))
